import styles from './HowToRead.module.css';

const items = [
  {
    n: '01',
    title: 'The score is reception, not capability.',
    body:
      'A family that wins evaluations can still rank low here, and a family with mediocre benchmarks can rank high. The two metrics are measuring different things on purpose.',
  },
  {
    n: '02',
    title: 'Sample size is shown next to every score.',
    body:
      'A reception score with n\u00A0=\u00A035 is an opinion. A reception score with n\u00A0=\u00A0358 is a reading. The 95% bootstrap interval makes the difference visible without requiring trust.',
  },
  {
    n: '03',
    title: 'Tracked but not ranked is not the same as bad.',
    body:
      'Some families do not have enough high-confidence public discussion this week to rank with statistical care. They are listed separately, with observed scores shown for the curious.',
  },
];

export function HowToRead() {
  return (
    <section className={styles.section}>
      <header className={styles.header}>
        <p className={styles.eyebrow}>03 · How to read this page</p>
        <h2 className={styles.heading}>Three notes before you share the screenshot.</h2>
      </header>
      <ol className={styles.list}>
        {items.map((item) => (
          <li key={item.n} className={styles.item}>
            <span className={styles.itemNum}>{item.n}</span>
            <div className={styles.itemBody}>
              <h3 className={styles.itemTitle}>{item.title}</h3>
              <p className={styles.itemText}>{item.body}</p>
            </div>
          </li>
        ))}
      </ol>
    </section>
  );
}
